import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import {
  Bar,
  Header,
  Progress,
  Text,
  Wrapper,
} from '@components/Downloader/style';
import Loader from '@components/Loader';

const Downloader = ({ visible, progress }) =>
  visible ? (
    <Wrapper>
      <Header>
        Download is preparing in background.
        <br />
        Please do not close this page.
      </Header>{' '}
      {!isEmpty(progress) ? (
        <Progress>
          <Bar style={{ width: `${progress.progress}%` }} />
          <Text>{progress.progress}%</Text>
        </Progress>
      ) : (
        <Loader size={30} />
      )}
    </Wrapper>
  ) : null;

Downloader.defaultProps = {
  progress: {},
};
Downloader.propTypes = {
  visible: PropTypes.bool.isRequired,
  progress: PropTypes.object,
};

export default Downloader;
